<template>
  <div class='compliance-status-container'>
    <div class="compliance-status-text" :style="style">
      {{ getStatus }}
    </div>
  </div>
</template>

<script>

import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'StatusTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getStatus() {
      return this.item.status;
    },
    colorsForLevels() {
      const status = this.getStatus;
      if (status === this.$t('FAIL')) {
        return { color: '#DF399F' };
      }
      if (status === this.$t('INFO')) {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    style() {
      return {
        backgroundColor: hexToRgba(this.colorsForLevels.color, 0.1),
        ...this.colorsForLevels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.compliance-status-container {
  .compliance-status-text{
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-semibold;
    line-height: 1.2em;
    display: flex;
    align-items: center;
    width: rem(70);
    height: rem(25);
    justify-content: center;
    margin-top: rem(12);
    border-radius: $radius-md;
  }
}

</style>
